import { useLocation } from "react-router-dom";
import { StepIndicator } from "../../components/Atoms/StepIndicator";
import {
  AGENDAMENTO_V2_STEPS,
  AGENDAMENTO_V2_LOTE_STEPS,
  getStepFromPath,
  isAgendamentoLotePath,
} from "./agendamentoV2Steps";
import { twMerge } from "tailwind-merge";

export const useAgendamentoStepIndicator = (className?: string) => {
  const location = useLocation();
  const activeStep = getStepFromPath(location.pathname);

  const steps = isAgendamentoLotePath(location.pathname)
    ? AGENDAMENTO_V2_LOTE_STEPS
    : AGENDAMENTO_V2_STEPS;

  if (!activeStep) {
    return null;
  }

  return (
    <StepIndicator
      steps={steps}
      activeStep={activeStep}
      className={twMerge("hidden md:flex", className)}
    />
  );
};
